import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel} from "react-bootstrap";
import ReactNotify from 'react-notify';
import FerieService from "./FerieService";
import FerieTable from "./components/FerieTable";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonAdd, TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import DateFormat from "../../../../../utilities/DateAndTimeFormat";
import moment from "moment";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import ScrollUtilities from "../../../../../utilities/ScrollUtilities";


export default class FerieContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ferie: [],
            data_start: null,
            data_koniec: null,
            edycja: null,
            validatorMessages: [],

        };
        this.getFerie = this.getFerie.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onClickAnuluj = this.onClickAnuluj.bind(this)
        this.onChangeStart = this.onChangeStart.bind(this)
        this.onChangeKoniec = this.onChangeKoniec.bind(this)
    }

    componentDidMount() {
        this.getFerie();
    }

    getFerie() {
        FerieService.getFerie().then(function (response) {
            this.setState({ferie: response.data.content})
        }.bind(this))
    }

    onClickEdytuj(obj) {
        this.setState({edycja: obj, data_start: moment(obj.dataOd), data_koniec: moment(obj.dataDo)})
        ScrollUtilities.scrollToTop()
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc ferie: ' + obj.dataOd + ' - ' + obj.dataDo)) {
            FerieService.deleteFerie(obj.id).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto ferie', "", 3000)
                    this.getFerie();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania ferii', "", 3000)
                }
            }.bind(this))
        }
    }

    onClickAnuluj() {
        this.setState({edycja: null, data_start: null, data_koniec: null})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {
        let poprawne = true; this.state.validatorMessages = [];

        if(!Boolean(this.state.data_start)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono daty rozpoczęcia')
        }

        if(!Boolean(this.state.data_koniec)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono daty zakończenia')
        }

        if(this.state.data_koniec < this.state.data_start){
            poprawne = false;
            this.dodajDoValidatorMessages('Data rozpoczęcia nie może być późniejsza od daty zakończenia')
        }


        if (poprawne) {

            this.state.validatorMessages = [];

            let obj = {
                dataOd: DateFormat.formatYYYYMMDD(this.state.data_start),
                dataDo: DateFormat.formatYYYYMMDD(this.state.data_koniec)
            }

            if (Boolean(this.state.edycja)) {
                FerieService.editFerie(this.state.edycja.id,obj).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie edytowano ferie', "", 3000)
                        this.getFerie();
                    }
                    else {
                        this.refs.notificator.error('Wystąpił błąd edycji dodawania ferii', "", 3000)
                    }
                }.bind(this))

            }
            else {
                // dodawanie
                FerieService.addFerie(obj).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie dodano ferie', "", 3000)
                        this.getFerie();
                    }
                    else {
                        this.refs.notificator.error('Wystąpił błąd podczas dodawania ferii', "", 3000)
                    }
                }.bind(this))
            }

            this.setState({
                edycja: null, data_start: null, data_koniec: null
            })
        }
    }

    onChangeStart(e) {
        this.setState({data_start: e})
    }

    onChangeKoniec(e) {
        this.setState({data_koniec: e})
    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <Row>
                    <Col xs={12}>
                        <Form inline={true}>
                            <div>
                                <ControlLabel>Zakres dat ferii od - do</ControlLabel>
                            </div>
                            <FormGroup>
                                <TopInputDate onChange={this.onChangeStart} value={this.state.data_start}/>
                                <div className={'add-space'}></div>
                                <TopInputDate onChange={this.onChangeKoniec} value={this.state.data_koniec}/>
                                <div className={'add-space'}></div>
                                {
                                    (Boolean(this.state.edycja)) ?
                                        <div style={{display: 'inline-block'}}>

                                            <TopButtonCancel onClick={this.onClickAnuluj}/>
                                            <TopButtonSave onClick={this.onClickZapisz}/>
                                        </div>
                                        :
                                        <TopButtonAdd onClick={this.onClickZapisz} text={'Dodaj nowy'}/>

                                }
                            </FormGroup>
                            <FormGroup>
                                <ValidatorMessages messages={this.state.validatorMessages}/>
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col xs={12}>
                        <FerieTable
                            data={this.state.ferie}
                            wlaczSzukanie={true}
                            handleEdytuj={this.onClickEdytuj}
                            handleUsun={this.onClickUsun}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/kalendarze/ferie/FerieContainer.js